import { Component, OnInit, inject } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ProcessInvitationModalComponent } from "@components/process-invitation-modal/process-invitation-modal.component";
import { ModalService } from "@odx/angular/components/modal";

@Component({
  selector: "app-confirm-project-invitation",
  imports: [],
  template: "",
  styles: "",
})
export class ConfirmProjectInvitationComponent implements OnInit {
  private route = inject(ActivatedRoute);

  private readonly modalService: ModalService = inject(ModalService);

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      const projectId = params.get("projectId");
      const invitationId = params.get("invitationId");

      this.modalService.open(ProcessInvitationModalComponent, {
        interactiveBackdrop: false,
        dismissable: false,
        data: {
          projectId: projectId,
          invitationId: invitationId,
        },
      });
    });
  }
}
